
import { Popup, Label, Icon } from "semantic-ui-react"

export default function QuestionIcon({content, size, color}) {
  return (<Popup content={content} trigger={<Label color={color} circular size={size}><Icon fitted name="question"/></Label>} />)
}